<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
    data(){
        return {
            show: true,
        }
    },

    mounted(): void
    {
        setTimeout(() => {
            this.show = false
        }, 10)
    },
})
</script>

<template>
    <Transition name="fade">
        <div id="bgFilter" ref="bgFilter" class="noselect" v-if="show"></div>
    </Transition>
</template>

<style scoped lang="scss">
#bgFilter {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: black;
}


.fade-enter-active,
.fade-leave-active {
    transition: opacity 2s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
